export default {
  "hierarchy": {
    "history": [
      "dateTimeRangePicker-history"
    ]
  },
  "props": {
    "default": {
      "data-error": true,
      "dateFormat": "MM/dd/yyyy",
      "rangeChangeType": null,
      "timeFormat": "hh:mm:ss a"
    },
    "history": {
      "data-error": true,
      "dateFormat": "MM/dd/yyyy",
      "rangeChangeType": null,
      "timeFormat": "hh:mm:ss a"
    }
  }
}